import { render, staticRenderFns } from "./user_profile.vue?vue&type=template&id=c9a43fc2&scoped=true&"
import script from "./user_profile.vue?vue&type=script&lang=ts&"
export * from "./user_profile.vue?vue&type=script&lang=ts&"
import style0 from "./user_profile.vue?vue&type=style&index=0&id=c9a43fc2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a43fc2",
  null
  
)

export default component.exports